var SimulateRemoteOperationRecordService = /** @class */ (function () {
    function SimulateRemoteOperationRecordService() {
    }
    SimulateRemoteOperationRecordService.prototype.record = function (args) {
    };
    return SimulateRemoteOperationRecordService;
}());
export { SimulateRemoteOperationRecordService };
